module.exports = __webpack_public_path__ + "static/media/hs_08.ed90a37f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_08.jpg
// module id = 5939
// module chunks = 0